package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets4 {
  internal val _14_yechezkel_31_txt: AssetResource by lazy { init__14_yechezkel_31_txt() }

  internal val _14_yechezkel_32_txt: AssetResource by lazy { init__14_yechezkel_32_txt() }

  internal val _14_yechezkel_33_txt: AssetResource by lazy { init__14_yechezkel_33_txt() }

  internal val _14_yechezkel_34_txt: AssetResource by lazy { init__14_yechezkel_34_txt() }

  internal val _14_yechezkel_35_txt: AssetResource by lazy { init__14_yechezkel_35_txt() }

  internal val _14_yechezkel_36_txt: AssetResource by lazy { init__14_yechezkel_36_txt() }

  internal val _14_yechezkel_37_txt: AssetResource by lazy { init__14_yechezkel_37_txt() }

  internal val _14_yechezkel_38_txt: AssetResource by lazy { init__14_yechezkel_38_txt() }

  internal val _14_yechezkel_39_txt: AssetResource by lazy { init__14_yechezkel_39_txt() }

  internal val _14_yechezkel_40_txt: AssetResource by lazy { init__14_yechezkel_40_txt() }

  internal val _14_yechezkel_41_txt: AssetResource by lazy { init__14_yechezkel_41_txt() }

  internal val _14_yechezkel_42_txt: AssetResource by lazy { init__14_yechezkel_42_txt() }

  internal val _14_yechezkel_43_txt: AssetResource by lazy { init__14_yechezkel_43_txt() }

  internal val _14_yechezkel_44_txt: AssetResource by lazy { init__14_yechezkel_44_txt() }

  internal val _14_yechezkel_45_txt: AssetResource by lazy { init__14_yechezkel_45_txt() }

  internal val _14_yechezkel_46_txt: AssetResource by lazy { init__14_yechezkel_46_txt() }

  internal val _14_yechezkel_47_txt: AssetResource by lazy { init__14_yechezkel_47_txt() }

  internal val _14_yechezkel_48_txt: AssetResource by lazy { init__14_yechezkel_48_txt() }

  internal val _15_hoshea_01_txt: AssetResource by lazy { init__15_hoshea_01_txt() }

  internal val _15_hoshea_02_txt: AssetResource by lazy { init__15_hoshea_02_txt() }

  internal val _15_hoshea_03_txt: AssetResource by lazy { init__15_hoshea_03_txt() }

  internal val _15_hoshea_04_txt: AssetResource by lazy { init__15_hoshea_04_txt() }

  internal val _15_hoshea_05_txt: AssetResource by lazy { init__15_hoshea_05_txt() }

  internal val _15_hoshea_06_txt: AssetResource by lazy { init__15_hoshea_06_txt() }

  internal val _15_hoshea_07_txt: AssetResource by lazy { init__15_hoshea_07_txt() }

  internal val _15_hoshea_08_txt: AssetResource by lazy { init__15_hoshea_08_txt() }

  internal val _15_hoshea_09_txt: AssetResource by lazy { init__15_hoshea_09_txt() }

  internal val _15_hoshea_10_txt: AssetResource by lazy { init__15_hoshea_10_txt() }

  internal val _15_hoshea_11_txt: AssetResource by lazy { init__15_hoshea_11_txt() }

  internal val _15_hoshea_12_txt: AssetResource by lazy { init__15_hoshea_12_txt() }

  internal val _15_hoshea_13_txt: AssetResource by lazy { init__15_hoshea_13_txt() }

  internal val _15_hoshea_14_txt: AssetResource by lazy { init__15_hoshea_14_txt() }

  internal val _16_yoel_01_txt: AssetResource by lazy { init__16_yoel_01_txt() }

  internal val _16_yoel_02_txt: AssetResource by lazy { init__16_yoel_02_txt() }

  internal val _16_yoel_03_txt: AssetResource by lazy { init__16_yoel_03_txt() }

  internal val _16_yoel_04_txt: AssetResource by lazy { init__16_yoel_04_txt() }

  internal val _17_amos_01_txt: AssetResource by lazy { init__17_amos_01_txt() }

  internal val _17_amos_02_txt: AssetResource by lazy { init__17_amos_02_txt() }

  internal val _17_amos_03_txt: AssetResource by lazy { init__17_amos_03_txt() }

  internal val _17_amos_04_txt: AssetResource by lazy { init__17_amos_04_txt() }

  internal val _17_amos_05_txt: AssetResource by lazy { init__17_amos_05_txt() }

  internal val _17_amos_06_txt: AssetResource by lazy { init__17_amos_06_txt() }

  internal val _17_amos_07_txt: AssetResource by lazy { init__17_amos_07_txt() }

  internal val _17_amos_08_txt: AssetResource by lazy { init__17_amos_08_txt() }

  internal val _17_amos_09_txt: AssetResource by lazy { init__17_amos_09_txt() }

  internal val _18_ovadia_01_txt: AssetResource by lazy { init__18_ovadia_01_txt() }

  internal val _19_yona_01_txt: AssetResource by lazy { init__19_yona_01_txt() }

  internal val _19_yona_02_txt: AssetResource by lazy { init__19_yona_02_txt() }

  internal val _19_yona_03_txt: AssetResource by lazy { init__19_yona_03_txt() }

  internal val _19_yona_04_txt: AssetResource by lazy { init__19_yona_04_txt() }

  internal fun values(): List<AssetResource> = listOf(_14_yechezkel_31_txt, _14_yechezkel_32_txt,
      _14_yechezkel_33_txt, _14_yechezkel_34_txt, _14_yechezkel_35_txt, _14_yechezkel_36_txt,
      _14_yechezkel_37_txt, _14_yechezkel_38_txt, _14_yechezkel_39_txt, _14_yechezkel_40_txt,
      _14_yechezkel_41_txt, _14_yechezkel_42_txt, _14_yechezkel_43_txt, _14_yechezkel_44_txt,
      _14_yechezkel_45_txt, _14_yechezkel_46_txt, _14_yechezkel_47_txt, _14_yechezkel_48_txt,
      _15_hoshea_01_txt, _15_hoshea_02_txt, _15_hoshea_03_txt, _15_hoshea_04_txt, _15_hoshea_05_txt,
      _15_hoshea_06_txt, _15_hoshea_07_txt, _15_hoshea_08_txt, _15_hoshea_09_txt, _15_hoshea_10_txt,
      _15_hoshea_11_txt, _15_hoshea_12_txt, _15_hoshea_13_txt, _15_hoshea_14_txt, _16_yoel_01_txt,
      _16_yoel_02_txt, _16_yoel_03_txt, _16_yoel_04_txt, _17_amos_01_txt, _17_amos_02_txt,
      _17_amos_03_txt, _17_amos_04_txt, _17_amos_05_txt, _17_amos_06_txt, _17_amos_07_txt,
      _17_amos_08_txt, _17_amos_09_txt, _18_ovadia_01_txt, _19_yona_01_txt, _19_yona_02_txt,
      _19_yona_03_txt, _19_yona_04_txt)
}

private fun init__14_yechezkel_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-31.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-31.txt")

private fun init__14_yechezkel_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-32.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-32.txt")

private fun init__14_yechezkel_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-33.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-33.txt")

private fun init__14_yechezkel_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-34.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-34.txt")

private fun init__14_yechezkel_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-35.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-35.txt")

private fun init__14_yechezkel_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-36.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-36.txt")

private fun init__14_yechezkel_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-37.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-37.txt")

private fun init__14_yechezkel_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-38.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-38.txt")

private fun init__14_yechezkel_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-39.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-39.txt")

private fun init__14_yechezkel_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-40.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-40.txt")

private fun init__14_yechezkel_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-41.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-41.txt")

private fun init__14_yechezkel_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-42.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-42.txt")

private fun init__14_yechezkel_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-43.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-43.txt")

private fun init__14_yechezkel_44_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-44.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-44.txt")

private fun init__14_yechezkel_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-45.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-45.txt")

private fun init__14_yechezkel_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-46.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-46.txt")

private fun init__14_yechezkel_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-47.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-47.txt")

private fun init__14_yechezkel_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-48.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-48.txt")

private fun init__15_hoshea_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-01.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-01.txt")

private fun init__15_hoshea_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-02.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-02.txt")

private fun init__15_hoshea_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-03.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-03.txt")

private fun init__15_hoshea_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-04.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-04.txt")

private fun init__15_hoshea_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-05.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-05.txt")

private fun init__15_hoshea_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-06.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-06.txt")

private fun init__15_hoshea_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-07.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-07.txt")

private fun init__15_hoshea_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-08.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-08.txt")

private fun init__15_hoshea_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-09.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-09.txt")

private fun init__15_hoshea_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-10.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-10.txt")

private fun init__15_hoshea_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-11.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-11.txt")

private fun init__15_hoshea_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-12.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-12.txt")

private fun init__15_hoshea_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-13.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-13.txt")

private fun init__15_hoshea_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_15_hoshea-14.txt\")") as String, rawPath =
    "allChapters/_15_hoshea-14.txt")

private fun init__16_yoel_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_16_yoel-01.txt\")") as String, rawPath =
    "allChapters/_16_yoel-01.txt")

private fun init__16_yoel_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_16_yoel-02.txt\")") as String, rawPath =
    "allChapters/_16_yoel-02.txt")

private fun init__16_yoel_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_16_yoel-03.txt\")") as String, rawPath =
    "allChapters/_16_yoel-03.txt")

private fun init__16_yoel_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_16_yoel-04.txt\")") as String, rawPath =
    "allChapters/_16_yoel-04.txt")

private fun init__17_amos_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-01.txt\")") as String, rawPath =
    "allChapters/_17_amos-01.txt")

private fun init__17_amos_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-02.txt\")") as String, rawPath =
    "allChapters/_17_amos-02.txt")

private fun init__17_amos_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-03.txt\")") as String, rawPath =
    "allChapters/_17_amos-03.txt")

private fun init__17_amos_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-04.txt\")") as String, rawPath =
    "allChapters/_17_amos-04.txt")

private fun init__17_amos_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-05.txt\")") as String, rawPath =
    "allChapters/_17_amos-05.txt")

private fun init__17_amos_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-06.txt\")") as String, rawPath =
    "allChapters/_17_amos-06.txt")

private fun init__17_amos_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-07.txt\")") as String, rawPath =
    "allChapters/_17_amos-07.txt")

private fun init__17_amos_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-08.txt\")") as String, rawPath =
    "allChapters/_17_amos-08.txt")

private fun init__17_amos_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_17_amos-09.txt\")") as String, rawPath =
    "allChapters/_17_amos-09.txt")

private fun init__18_ovadia_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_18_ovadia-01.txt\")") as String, rawPath =
    "allChapters/_18_ovadia-01.txt")

private fun init__19_yona_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_19_yona-01.txt\")") as String, rawPath =
    "allChapters/_19_yona-01.txt")

private fun init__19_yona_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_19_yona-02.txt\")") as String, rawPath =
    "allChapters/_19_yona-02.txt")

private fun init__19_yona_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_19_yona-03.txt\")") as String, rawPath =
    "allChapters/_19_yona-03.txt")

private fun init__19_yona_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_19_yona-04.txt\")") as String, rawPath =
    "allChapters/_19_yona-04.txt")

public actual val SharedRes.assets.allChapters._14_yechezkel_31_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_31_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_32_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_32_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_33_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_33_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_34_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_34_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_35_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_35_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_36_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_36_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_37_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_37_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_38_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_38_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_39_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_39_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_40_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_40_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_41_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_41_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_42_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_42_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_43_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_43_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_44_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_44_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_45_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_45_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_46_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_46_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_47_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_47_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_48_txt: AssetResource
  get() = CommonMainAssets4._14_yechezkel_48_txt

public actual val SharedRes.assets.allChapters._15_hoshea_01_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_01_txt

public actual val SharedRes.assets.allChapters._15_hoshea_02_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_02_txt

public actual val SharedRes.assets.allChapters._15_hoshea_03_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_03_txt

public actual val SharedRes.assets.allChapters._15_hoshea_04_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_04_txt

public actual val SharedRes.assets.allChapters._15_hoshea_05_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_05_txt

public actual val SharedRes.assets.allChapters._15_hoshea_06_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_06_txt

public actual val SharedRes.assets.allChapters._15_hoshea_07_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_07_txt

public actual val SharedRes.assets.allChapters._15_hoshea_08_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_08_txt

public actual val SharedRes.assets.allChapters._15_hoshea_09_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_09_txt

public actual val SharedRes.assets.allChapters._15_hoshea_10_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_10_txt

public actual val SharedRes.assets.allChapters._15_hoshea_11_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_11_txt

public actual val SharedRes.assets.allChapters._15_hoshea_12_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_12_txt

public actual val SharedRes.assets.allChapters._15_hoshea_13_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_13_txt

public actual val SharedRes.assets.allChapters._15_hoshea_14_txt: AssetResource
  get() = CommonMainAssets4._15_hoshea_14_txt

public actual val SharedRes.assets.allChapters._16_yoel_01_txt: AssetResource
  get() = CommonMainAssets4._16_yoel_01_txt

public actual val SharedRes.assets.allChapters._16_yoel_02_txt: AssetResource
  get() = CommonMainAssets4._16_yoel_02_txt

public actual val SharedRes.assets.allChapters._16_yoel_03_txt: AssetResource
  get() = CommonMainAssets4._16_yoel_03_txt

public actual val SharedRes.assets.allChapters._16_yoel_04_txt: AssetResource
  get() = CommonMainAssets4._16_yoel_04_txt

public actual val SharedRes.assets.allChapters._17_amos_01_txt: AssetResource
  get() = CommonMainAssets4._17_amos_01_txt

public actual val SharedRes.assets.allChapters._17_amos_02_txt: AssetResource
  get() = CommonMainAssets4._17_amos_02_txt

public actual val SharedRes.assets.allChapters._17_amos_03_txt: AssetResource
  get() = CommonMainAssets4._17_amos_03_txt

public actual val SharedRes.assets.allChapters._17_amos_04_txt: AssetResource
  get() = CommonMainAssets4._17_amos_04_txt

public actual val SharedRes.assets.allChapters._17_amos_05_txt: AssetResource
  get() = CommonMainAssets4._17_amos_05_txt

public actual val SharedRes.assets.allChapters._17_amos_06_txt: AssetResource
  get() = CommonMainAssets4._17_amos_06_txt

public actual val SharedRes.assets.allChapters._17_amos_07_txt: AssetResource
  get() = CommonMainAssets4._17_amos_07_txt

public actual val SharedRes.assets.allChapters._17_amos_08_txt: AssetResource
  get() = CommonMainAssets4._17_amos_08_txt

public actual val SharedRes.assets.allChapters._17_amos_09_txt: AssetResource
  get() = CommonMainAssets4._17_amos_09_txt

public actual val SharedRes.assets.allChapters._18_ovadia_01_txt: AssetResource
  get() = CommonMainAssets4._18_ovadia_01_txt

public actual val SharedRes.assets.allChapters._19_yona_01_txt: AssetResource
  get() = CommonMainAssets4._19_yona_01_txt

public actual val SharedRes.assets.allChapters._19_yona_02_txt: AssetResource
  get() = CommonMainAssets4._19_yona_02_txt

public actual val SharedRes.assets.allChapters._19_yona_03_txt: AssetResource
  get() = CommonMainAssets4._19_yona_03_txt

public actual val SharedRes.assets.allChapters._19_yona_04_txt: AssetResource
  get() = CommonMainAssets4._19_yona_04_txt
